import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import SendIcon from '@mui/icons-material/Send'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Fab,
  Grow,
  IconButton,
  Typography,
} from '@mui/material'
import { RadioGroup } from '@mui/material'
import { FormControlLabel } from '@mui/material'
import { Radio } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { sendShowImageCommandToChamberScreen } from 'src/consumer/services/featureServices'
import {
  PsychAssessmentImageGalleryContainer,
  PsychAssessmentImageGalleryImage,
  PsychAssessmentImageGalleryImageContainer,
} from 'src/mentor/components/AssessmentReport/components/styledComponents'
import { ChamberScreenSignallingSnackBarContext } from 'src/mentor/components/MentorClinicSomeChamberAutoJoiningPage/components/ChamberScreenSignallingSnackBarProvider'
import { getDataMapFromCommonResponse, getImageLink, isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'
import { getMPDataWithParams } from 'src/mentor/services'
import ClearIcon from '@mui/icons-material/Clear'

export default function PsychAssessmentViewerAndSignaller({
  psychAssessmentId,
  chamberRoomId,
  assessmentData,
  setAssessmentData,
}) {
  const [assessmentImages, setAssessmentImages] = useState([])
  const [showDialog, setShowDialog] = useState(false)
  const defaultTimeToShowSignal = 3600
  const { showSnackBar, sentSignalRelatedData } = useContext(ChamberScreenSignallingSnackBarContext)

  async function getAssessmentData() {
    const resp = await getMPDataWithParams(`/api/secure/teacher/psych-assessment/get`, {
      id: psychAssessmentId,
    })
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const respData = getDataMapFromCommonResponse(resp)
        const psychAssessmentData = respData?.['psych-assessment']
        const transformedImages = psychAssessmentData?.assessmentImages
        setAssessmentImages(transformedImages)
        setAssessmentData(psychAssessmentData)
      }
    }
  }

  async function showAssessmentImageToPatient(image) {
    const resp = await sendShowImageCommandToChamberScreen(chamberRoomId, 'any-image', {
      imageId: image.imageId,
      duration: defaultTimeToShowSignal,
    })
    if (resp.status === 200 && isCommonResponseSuccessfulV2(resp)) {
      showSnackBar(
        'Showing Assessment Image to patient',
        defaultTimeToShowSignal,
        chamberRoomId,
        null,
        {
          assessmentImageId: image.assessmentImgId,
        },
      )
    }
  }

  useEffect(() => {
    if (psychAssessmentId) {
      getAssessmentData()
    }
  }, [psychAssessmentId])

  return (
    <>
      {/* TAT-specific: Show images to the patient. Uncomment to bring back for TAT assessment.
      <div className="mt-4">
        <AssessmentImagesGalleryDialog
          setShowDialog={setShowDialog}
          assessmentImages={assessmentImages}
          showAssessmentImageToPatient={showAssessmentImageToPatient}
          currentlyShowingImageId={sentSignalRelatedData?.assessmentImageId}
          assessmentData={assessmentData}
          setAssessmentData={setAssessmentData}
        />
      </div>
      */}
    </>
  )
}

function AssessmentImagesGalleryDialog({
  setShowDialog,
  assessmentImages,
  showAssessmentImageToPatient,
  currentlyShowingImageId,
  assessmentData,
  setAssessmentData,
}) {
  console.log({ assessmentImages })
  const [selectedImage, setSelectedImage] = useState(null)

  const handleImageClick = (imageObject) => {
    setSelectedImage(imageObject)
  }

  const handleBack = () => {
    setSelectedImage(null)
  }

  const handleAnswerChange = (key, value) => {
    setAssessmentData((prev) => {
      const existingAnswers = prev?.answers || []
      const existingAnswer = existingAnswers.find(
        (answer) => answer.storyId === selectedImage.assessmentImgId,
      )

      if (existingAnswer) {
        // If answer exists, update it
        return {
          ...prev,
          answers: existingAnswers.map((answer) => {
            if (answer.storyId === selectedImage.assessmentImgId) {
              return {
                ...answer,
                [key]: value,
              }
            }
            return answer
          }),
        }
      } else {
        // If answer doesn't exist, add new one
        return {
          ...prev,
          answers: [
            ...existingAnswers,
            {
              storyId: selectedImage.assessmentImgId,
              [key]: value,
            },
          ],
        }
      }
    })
  }

  if (selectedImage) {
    return (
      <>
        <h4 style={{ borderBottom: '1px solid #e0e0e0', padding: '8px 16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <IconButton onClick={handleBack}>
                <ArrowBackIcon />
              </IconButton>
              <h4 style={{ margin: 0 }}>Image View</h4>
            </div>
          </div>
        </h4>
        <div className="p-3" style={{ background: '#dcdcdc47', paddingTop: '8px' }}>
          <div
            style={{
              display: 'flex',
              gap: '8px',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
            }}
          >
            {/* TAT-specific: Inquiry & Analysis of Form. Uncomment to bring back for TAT.
            <div className="d-flex flex-column gap-1">
              <ListWithHeading
                heading="1. Inquiry"
                items={[
                  '(i) about non-complaiance',
                  '(ii) about the plot',
                  '(iii) about the identification and empathy',
                  '(iv) about ambiguities',
                  '(v) about omission',
                  '(vi) about introduced content',
                  '(vii) about peculiarities of utterances, pauses hesitation, rejection and the like',
                  '(viii) about perceptual distortions',
                  '(ix) about story interruptions',
                  '(x) about about the best liked and least liked pictures',
                  '(xi) about emphasis on time',
                ]}
              />
              <ListWithHeading
                heading="2. Analysis of Form"
                items={[
                  '(i) Plot',
                  '(ii) Organisation',
                  '(iii) Fantasies-Imagination',
                  '(iv) Language',
                  '(v) Observation of Details',
                ]}
              />
            </div>
            */}
            <div style={{ width: '100%', position: 'relative' }}>
              {currentlyShowingImageId === selectedImage?.assessmentImgId && (
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: '8px',
                    background: 'rgba(0, 0, 0, 0.5)',
                    color: 'white',
                  }}
                >
                  Currently Showing
                </div>
              )}
              <PsychAssessmentImageGalleryImage
                src={getImageLink(selectedImage?.imageId)}
                alt="Assessment"
                style={{ maxHeight: '200px' }}
              />
            </div>
            {/* TAT-specific: Show to Patient button. Uncomment to bring back for TAT.
            <div className="d-flex flex-column gap-1 flex-shrink-0">
              <Button
                variant="contained"
                onClick={() => showAssessmentImageToPatient(selectedImage)}
                sx={{ flexShrink: 0 }}
                endIcon={<SendIcon />}
              >
                Show to Patient
              </Button>
            </div>
            */}
          </div>
          {/* TAT-specific: Need/personality variables (Murray). Uncomment to bring back for TAT.
          {Object.entries({
            abasement: 'Abasement',
            achievement: 'Achievement',
            affiliation: 'Affiliation',
            aggression: 'Aggression',
            autonomy: 'Autonomy',
            counteraction: 'Counteraction',
            defendance: 'Defendance',
            deference: 'Deference',
            dominance: 'Dominance',
            exhibition: 'Exhibition',
            harmAvoidance: 'Harm Avoidance',
            infavoidance: 'Infavoidance',
            nurturance: 'Nurturance',
            order: 'Order',
            play: 'Play',
            rejection: 'Rejection',
            sentience: 'Sentience',
            sexual: 'Sexual',
            succorance: 'Succorance',
            understanding: 'Understanding',
          }).map(([key, label]) => (
            <RadioButtonGroup
              key={key}
              label={label}
              value={
                assessmentData?.answers?.find((a) => a.storyId === selectedImage.assessmentImgId)?.[
                  key
                ]
              }
              onChange={(v) => {
                console.log({ v, key })
                handleAnswerChange(key, v)
              }}
              options={[
                { value: 'low', label: 'Low' },
                { value: 'medium', label: 'Medium' },
                { value: 'high', label: 'High' },
              ]}
            />
          ))}
          */}
        </div>
      </>
    )
  }

  // TAT-specific: Show Images to the patient gallery. Uncomment to bring back for TAT.
  return null
  /*
  return (
    <>
      <h4 style={{ borderBottom: '1px solid #e0e0e0', padding: '8px 16px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <h4 style={{ margin: 0 }}>Show Images to the patient</h4>
            <i className="fw-light fs-7" style={{ textDecoration: 'underline' }}>
              You can click on one of these images to show it on the patient&apos;s screen.
            </i>
          </div>
        </div>
      </h4>
      <div className="p-3" style={{ background: '#dcdcdc47', paddingTop: '8px' }}>
        <PsychAssessmentImageGalleryContainer>
          {assessmentImages?.map((image, index) => (
            <PsychAssessmentImageGalleryImageContainer
              key={image.assessmentImgId}
              onClick={() => handleImageClick(image)}
            >
              {currentlyShowingImageId === image.assessmentImgId && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'rgba(0, 0, 0, 0.5)',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: 'white',
                    }}
                  >
                    Currently Showing
                  </div>
                </div>
              )}
              <PsychAssessmentImageGalleryImage
                src={getImageLink(image.imageId)}
                alt={`Assessment ${image.assessmentImgId}`}
              />
            </PsychAssessmentImageGalleryImageContainer>
          ))}
        </PsychAssessmentImageGalleryContainer>
      </div>
    </>
  )
  */
}

const ListWithHeading = ({ heading, items = [] }) => {
  return (
    <Accordion elevation={0}>
      <AccordionSummary>{heading}</AccordionSummary>
      <AccordionDetails>
        <ul style={{ margin: 0, paddingLeft: '20px' }}>
          {items.map((item, index) => (
            <li className="fs-8" key={index}>
              {item}
            </li>
          ))}
        </ul>
      </AccordionDetails>
    </Accordion>
  )
}

const RadioButtonGroup = ({ label, value, onChange, options }) => {
  console.log({ value })

  const handleClear = () => {
    onChange(null)
  }

  return (
    <Box sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
      <Typography sx={{ mb: 1, fontWeight: 500, width: '150px' }}>{label}</Typography>
      <RadioGroup row value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio size="small" />}
            label={option.label}
            sx={{ mr: 2 }}
          />
        ))}
      </RadioGroup>
      <Grow in={!!value}>
        <Fab
          onClick={handleClear}
          sx={{ height: '30px', width: '30px', minHeight: 0, minWidth: 0 }}
          color="error"
        >
          <ClearIcon fontSize="small" />
        </Fab>
      </Grow>
    </Box>
  )
}
